<template>
  <div class="container">
    <Loader v-if="isLoading" />
    <div id="typeform-container" />
  </div>
</template>

<script>
import Loader from '@/components/Loader';

import { API } from '@/services/';
import { API_GET_TEST_BY_ID } from '@/helpers/config';

export default {
  components: {
    Loader,
  },
  data: () => ({
    isLoading: true,
    test: null,
  }),
  mounted() {
    const url = API_GET_TEST_BY_ID + this.$route.params.id;
    API.get(url)
      .then((response) => {
        this.test = response.data;
      })
      .then(() => {
        // after typeform embed script is loaded
        this.getTypeformEmbedJs().onload = () => {
          this.isLoading = false;
          this.updateTypeformHeight();
          // create embeded type form
          this.createTypeformEmbed(this.test.typeForm.id);
        };
      })
      .catch((error) => {
        if (error.response.status === 204 || error.response.status === 400)
          this.$router.push('/404');
      });
  },
  methods: {
    updateTypeformHeight() {
      const appHeight = document.querySelector('#app').clientHeight;
      document.querySelector(
        '#typeform-container'
      ).style.height = `${appHeight}px`;
    },
    // get typeform embed script from external source and append it to head
    getTypeformEmbedJs() {
      const typeformEmbedScript = document.createElement('script');
      typeformEmbedScript.setAttribute(
        'src',
        'https://embed.typeform.com/embed.js'
      );
      document.head.appendChild(typeformEmbedScript);

      return typeformEmbedScript;
    },
    createTypeformEmbed(typeformId) {
      const testId = this.$route.params.id;
      const userId = this.$route.query.id;
      const userGender = this.$route.query.gender;
      const src = this.$route.query.src;
      const city = this.$route.query.city;
      const typeformUrl = `https://senkimsin.typeform.com/to/${typeformId}?id=${userId}&test_id=${testId}&gender=${userGender}&src=${src}&city=${city}`;

      const embedElement = document.querySelector('#typeform-container');

      window.typeformEmbed.makeWidget(embedElement, typeformUrl, {
        hideFooter: true,
        hideHeaders: true,
        opacity: 75,
      });
    },
  },
};
</script>
<style scoped>
</style>
